export default __webpack_public_path__ + "static/media/SeleccionePeriodos.94429b9c.png";